module.exports = __webpack_public_path__ + "img/01.6adfdb56.jpg";